import { type Component, onCleanup } from 'solid-js';
import { RgbColor } from 'solid-color';
import { ColorPickerPanel } from './ColorPickerPanel';

export interface ColorPickerProps {
  initialColor?: string;
  useTransparency?: boolean;
  initialTransparency?: number;
  /**
   * Optional ByLayer functionality
   */
  byLayerColor?: string | null;
  /**
   * Object's specific color (null means ByLayer)
   */
  objectColor?: string | null;
  /**
   * Optional different alignment of the color picker
   */
  cssAlignment?: string;
  onClose?(): void;
  onSave?(rgb: RgbColor): void;
  onChange?(rgb: RgbColor): void;
  /**
   * When true, do not visually mark any palette color as selected
   */
  suppressSelection?: boolean;
  /**
   * Called when the transparency slider value is changed
   * @param transparency Normalized transparency value (0.0 - 1.0 inc)
   */
  onTransparencyChange?(transparency: number): void;
  onByLayerSelect?(): void;
  onReset?(): void;
  showResetButton?: boolean;
}

export const ColorPicker: Component<ColorPickerProps> = (props) => {
  onCleanup(() => props.onClose?.());

  return (
    <div
      data-testid="color-picker-container"
      class={`z-dropdown ${props.cssAlignment || props.cssAlignment === '' ? '' : 'absolute left-0 bottom-full mb-2'}`}
    >
      <ColorPickerPanel
        initialColor={props.initialColor}
        useTransparency={props.useTransparency}
        initialTransparency={props.initialTransparency}
        byLayerColor={props.byLayerColor}
        objectColor={props.objectColor}
        suppressSelection={props.suppressSelection}
        onTransparencyChange={props.onTransparencyChange}
        onByLayerSelect={props.onByLayerSelect}
        onChange={props.onChange}
        onSave={props.onSave}
        onReset={props.onReset}
        showResetButton={props.showResetButton}
      />
    </div>
  );
};

export default ColorPicker;
